import { memo, useEffect, useRef } from "react";
import { type OfficeData } from "../api/types";
import { useTranslation } from "react-i18next";
import { isLocal } from "../api/config";

interface Props {
  officeData: OfficeData;
  embed?: boolean;
}

const OfficeFrame = memo(({ officeData, embed }: Props) => {
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);

  const { accessToken, accessTokenTtl, userId, ownerId, officeActionUrl } =
    officeData;

  useEffect(() => {
    formRef.current?.submit();
  }, []);

  if (isLocal) {
    return (
      <div className="flex h-full flex-col items-center justify-center text-center">
        <p>{t(($) => $.commons.errors.officeLocalhost)}</p>
      </div>
    );
  }

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        overflow: "hidden",
        msContentZooming: "none",
        height: embed ? "100%" : "auto",
      }}
    >
      <form
        id="office_form"
        name="office_form"
        target="office_frame"
        action={officeActionUrl}
        method="post"
        ref={formRef}
      >
        <input name="access_token" value={accessToken} type="hidden" />
        <input name="access_token_ttl" value={accessTokenTtl} type="hidden" />
        <input name="user_id" value={userId} type="hidden" />
        <input name="owner_id" value={ownerId} type="hidden" />
      </form>

      <iframe
        style={{
          width: "100%",
          height: "100%",
          position: embed ? "static" : "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          margin: 0,
          border: "none",
        }}
        name="office_frame"
        id="office_frame"
        title="Office Frame"
        allowFullScreen={true}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
      />
    </div>
  );
});

OfficeFrame.displayName = "OfficeFrame";

export const EmptyDocument = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col items-center justify-center text-center">
      <p className="pb-2">{t(($) => $.commons.document.emptyDocument)}</p>
      <p>{t(($) => $.commons.document.emptyDocumentDescription)}</p>
      <p>{t(($) => $.commons.document.emptyDocumentDescription2)}</p>
    </div>
  );
};

export default OfficeFrame;
